import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { HelpPageComponent } from './help.component';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: HelpPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class HelpPageRoutingModule {}
